const SfrInteraction = {
    init() {
        const body = document.body;
        const facetsBar = document.querySelector('.facets__bar');
        const facetsBarWrapper = document.querySelector('.facets__bar-wrapper');
        const facetsGroupWrapper = document.querySelector('.facets__group-wrapper');
        const facetsToggle = document.querySelector('.facets__toggle');
        const facetsClose = document.querySelector('.facets__close');
        const facetsSubmit = document.querySelector('.facets__submit');

        if (facetsBarWrapper && facetsBar) {
            window.addEventListener("scroll", function () {
                checkOffsetTop(facetsBarWrapper, facetsBar);
            });
        }

        if (facetsGroupWrapper) {
            if (window.innerWidth < 640) {
                facetsGroupWrapper.classList.add('dark-theme');
                checkOffsetTop(facetsBarWrapper, facetsBar);
            }

            window.addEventListener("resize", function () {
                if (window.innerWidth < 640) {
                    facetsGroupWrapper.classList.add('dark-theme');
                } else {
                    facetsGroupWrapper.classList.remove('dark-theme');
                }

                checkOffsetTop(facetsBarWrapper, facetsBar);
            });
        }

        if (facetsGroupWrapper && facetsToggle) {
            facetsToggle.addEventListener('click', (e) => {
                facetsGroupWrapper.classList.add('active');
                body.classList.add('overflow-hidden');

            });
        }

        if (facetsGroupWrapper && facetsClose) {
            facetsClose.addEventListener('click', (e) => {
                facetsGroupWrapper.classList.remove('active');
                body.classList.remove('overflow-hidden');
            });
        }

        if (facetsGroupWrapper && facetsSubmit) {
            facetsSubmit.addEventListener('click', (e) => {
                facetsGroupWrapper.classList.remove('active');
                body.classList.remove('overflow-hidden');
            });
        }
    }
};

function checkOffsetTop(wrapper, facetsBar) {
    if (window.scrollY > (wrapper.offsetTop)) {
        facetsBar.classList.add('fixed');
    } else {
        facetsBar.classList.remove('fixed');
    }
}

window.addEventListener('DOMContentLoaded', () => {
    SfrInteraction.init();
});